/**
 * Frontend kill switches for features whose backends are not ready yet.
 * Flip the relevant flag to `true` once the corresponding API ships.
 */
export const FEATURE_FLAGS = {
  /** Settings checklist + sidebar Getting Started entry. */
  gettingStarted: false,
  /** One-time guided tours (auto-start + overlay). */
  tours: false,
  /** Refer & earn settings page. */
  referrals: false,
  /** Interview scorecards: Settings › Scorecards, the job Scorecards tab, the candidate drawer tab, and the
   * Notetaker settings / attention surfaces that only matter with scorecards. */
  scorecards: false,
} as const;
